import {Component, Input, OnInit} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-pop-up',
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss']
})
export class PopUpComponent  implements OnInit  {

  @Input() message: any;
  @Input() modalType: any;
  @Input() error: any;
  @Input() eventId: string;

  /**
   * Gdy podane, „Tak" NIE zamyka okna od razu: uruchamia akcję, pokazuje na sobie postęp
   * i zamyka okno dopiero po jej zakończeniu. Bez tego akcja startowała po zamknięciu okna
   * i nie było już czego oznaczyć jako „w toku".
   *
   * Nieustawione — okno zachowuje się jak dotąd, więc wszystkie dotychczasowe wywołania
   * openAccept() działają bez zmian.
   */
  @Input() confirmAction: () => Observable<any>;

  /** Klucz komunikatu na przycisku „Tak" w trakcie pracy — np. `BUTTONS.DELETING`. */
  @Input() confirmBusyLabel = 'BUTTONS.PROCESSING';

  /** Akcja trwa: „Tak" pokazuje postęp, „Anuluj" jest zablokowany. */
  busy = false;

  constructor(public activeModal: NgbActiveModal) {
  }

  /**
   * „Anuluj" w połowie usuwania zostawiłoby użytkownika bez informacji, czy operacja
   * doszła do skutku — żądanie leci dalej niezależnie od zamkniętego okna.
   */
  confirm(): void {
    if (!this.confirmAction) {
      this.activeModal.close('Yes click');
      return;
    }
    if (this.busy) {
      return;
    }

    this.busy = true;
    this.confirmAction().subscribe(
      result => this.activeModal.close(result === undefined ? 'Yes click' : result),
      // Rozróżnialne odrzucenie: dla wołającego nieudana akcja to co innego niż anulowanie.
      error => this.activeModal.dismiss({ actionFailed: true, error })
    );
  }

  // multi-line messages (e.g. the delete-account confirmation) use a top
  // margin instead of the default bottom margin so the title sits nicely
  get isMultilineMessage(): boolean {
    return typeof this.message === 'string' && this.message.includes('\n');
  }

  ngOnInit() {
  }

}
